import React from 'react'

import DeleteIcon from 'Assets/Images/icons/delete'
import StyledIconButton from '../../Form/StyledIconButton'

export const ButtonDeleteUnstyled = props => (
  <StyledIconButton
    className={props.className}
    label="Add Metric"
    onClick={props.onClickHandler}
    cypress_id={props.cypress_id}
  >
    <DeleteIcon />
  </StyledIconButton>
)
